var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.519,
    height: 30.519,
    viewBox: "0 0 30.519 30.519",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mark_email_read_black_18dp",
    transform: "translate(0.15 0.15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7959",
    "data-name": "Rectangle 7959",
    width: 30.519,
    height: 30.519,
    transform: "translate(-0.15 -0.15)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16756",
    "data-name": "Path 16756",
    d: "M13.559,19.688H5.2V9.24l8.363,5.022L22.04,9.24v6.11h2.077V5.508A1.513,1.513,0,0,0,22.609,4H4.508A1.513,1.513,0,0,0,3,5.508V20.592A1.513,1.513,0,0,0,4.508,22.1h9.05Zm9.05-13.317-9.05,4.9L5.2,6.371ZM19.23,23.609l-4.65-4.195,1.071-1.071,3.579,3.124,8.325-8.292,1.056,1.086Z",
    transform: "translate(1.551 2.06)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIconWhite);
export default __webpack_public_path__ + "static/media/emailIcon-white.a42fc17c2e9a4ff2319e941fb48e5209.svg";
export { ForwardRef as ReactComponent };